import React from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import { getAtmosphereReaction } from '../../utils/utils';

const useStyles = makeStyles(theme => ({
    primary: {
        fontSize: 18,
        fontWeight: 500,
        marginLeft: theme.spacing(1),
    },
    primaryLight: {
        color: '#fff'
    },
    primaryDark: {
        fontWeight: 700,
        color: '#112435'
    },
    
}));

const Feeling = ({ atmosphere, value, theme }) => {
    const classes = useStyles();

    return (
        <Box display="flex" alignItems="center" justifyContent="center">
            <img src={atmosphere? getAtmosphereReaction(atmosphere): getAtmosphereReaction('positive')} alt="feeling" />
            { value && 
                <Typography 
                    className={clsx(
                        theme? classes.primaryLight: classes.primaryDark, 
                        classes.primary
                    )}
                >
                    {value}%
                </Typography>
            }
        </Box>
    )
}

export default Feeling;
